module.exports = __webpack_public_path__ + "img/39_62.c3bd6ef6.png";